import { readonly, ref } from "vue";
export type AuthMode = "login" | "register";

const open = ref(false);
const mode = ref<AuthMode>("login");
const returnTo = ref("/");

export const useAuthModal = () => {
  const show = (m: AuthMode = "login", r = "/") => {
    mode.value = m;
    returnTo.value = r;
    open.value = true;
  };
  const close = () => {
    open.value = false;
  };
  const setMode = (m: AuthMode) => {
    mode.value = m;
  };
  return { open: readonly(open), mode: readonly(mode), returnTo: readonly(returnTo), show, close, setMode };
};
